import { render, staticRenderFns } from "./online.vue?vue&type=template&id=3b2bf29e&scoped=true&"
import script from "./online.vue?vue&type=script&lang=ts&"
export * from "./online.vue?vue&type=script&lang=ts&"
import style0 from "./online.vue?vue&type=style&index=0&id=3b2bf29e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2bf29e",
  null
  
)

export default component.exports